// extracted by mini-css-extract-plugin
export default {"innerContainer":"ShippingModal_innerContainer__dKHXi","columnContainer":"ShippingModal_columnContainer__CPMVB","footerContainer":"ShippingModal_footerContainer__fjhDl"};